/**
 * Service layer — the six gates (sheet 3 of docs/RULES_OF_FLOW.md; record in docs/GATES.md).
 * Talks to /api/gates only. Milestone gates are read and ticked by any signed-in user; the templates
 * are edited in Templates → Gates by anyone with the checklist-templates or admin module.
 */

async function authToken() {
  if (typeof window === 'undefined') return null
  for (let i = 0; i < 20; i++) {
    if (typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* not ready */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}
async function post(body) {
  const token = await authToken()
  const res = await fetch('/api/gates', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || ('Request failed: ' + res.status))
  return json
}

/** Plain labels for who provides an item. One place, so every screen says the same words. */
export const GATE_SOURCE_LABELS = {
  prior: 'Done already', client: 'Client', consultant: 'Consultant', agency: 'City', direction: 'Matt or Brandon', setup: 'Anyone',
}
export const GATE_SOURCE_KINDS = ['client', 'consultant', 'agency', 'setup', 'prior', 'direction']

// ── live gates ──
/** The gate on a milestone, created from its template on first read. `gate` is null when the type has none. */
export function getMilestoneGate(milestoneId) { return post({ action: 'forMilestone', milestoneId }) }
export function setGateItemStatus(itemId, status, { reason, note, memberId, memberName } = {}) {
  return post({ action: 'setItemStatus', itemId, status, reason, note, memberId, memberName })
}
/** A note on an answered kit item: who decides, how to get on site (database/365). */
export function setGateItemNote(itemId, note) {
  return post({ action: 'setItemNote', itemId, note })
}
/** Retired with the wait columns (step 6a): anything we wait on is a feeder now. Kept so old imports load. */
export function startGateWait() { return Promise.reject(new Error('Wait clocks were retired: anything we wait on is a feeder now.')) }

// ── a milestone type's kit, as shared project facts (step 6b, database/270) ──
/** { kit, items: [{ id, name, source_kind, usedBy }] } — kit is null when the type has none. */
export function getTypeKit(typeId) { return post({ action: 'typeKit', typeId }) }
/** Every fact in the firm list, with how many types use it — for "use an existing fact". */
export function getFactLibrary() { return post({ action: 'factLibrary' }) }
export function saveTypeKit(typeId, patch) { return post({ action: 'saveTypeKit', typeId, ...patch }) }
export function deleteTypeKit(typeId) { return post({ action: 'deleteTypeKit', typeId }) }
/** Pass { factId } to reuse a fact, or { name, sourceKind } to write a new one. */
export function addKitFact(typeId, fields) { return post({ action: 'addKitFact', typeId, ...fields }) }
export function removeKitFact(typeId, factId) { return post({ action: 'removeKitFact', typeId, factId }) }
/** Rewords a fact for EVERY type that uses it. */
export function updateKitFact(id, patch) { return post({ action: 'updateFact', id, ...patch }) }
export function reorderKit(typeId, factIds) { return post({ action: 'reorderKit', typeId, factIds }) }
